import React from 'react';
import { Link } from 'react-router-dom';
import logoZalo from '../../assets/image/logo/iconZalo.png';
import logoYoutube from '../../assets/image/logo/logoYoutube.png';
import logoFace from '../../assets/image/logo/logoFace.png';
import IconRobotic from '../../assets/image/logo-header.jpg';
import LogoBoCongThuong from '../../assets/image/logo/bct.cb85045e8b81c0a8dd5f.png';
import { addressStore } from '../view/tramBaoHanh';

const Footer = () => {
  return (
    <>
      <div className="footer">
        <div className="container" style={{ width: '65%' }}>
          <div className="row">
            <div className="col-md-3">
              <ul className="list-unstyled h-100 p-0">
                <li>
                  <p className="mb-3">
                    <img
                      src={IconRobotic}
                      className="position-relative"
                      style={{
                        width: 200,
                        height: 80,
                        objectFit: 'contain',
                        backgroundColor: 'transparent',
                        mixBlendMode: 'multiply',
                      }}
                      alt="logo"
                    />
                  </p>
                </li>
                <li>
                  <p style={{ fontSize: '19px', fontWeight: '700' }}>
                    Trung tâm bảo hành duy nhất <br /> <span> Ecovacs ủy quyền tại Việt Nam</span>
                  </p>
                </li>
                <br />
                {/* <div className="mt-4" style={{ color: "gray" }}>
                  Bản quyền thuộc về © CÔNG TY CỔ PHẦN CÔNG NGHỆ HỢP LONG.
                </div> */}
                <a target="_blank" href="http://online.gov.vn/Home/WebDetails/138686" rel="noreferrer">
                  <img
                    src={LogoBoCongThuong}
                    className="position-relative"
                    style={{
                      width: 160,
                      objectFit: 'contain',
                      backgroundColor: 'transparent',
                      mixBlendMode: 'multiply',
                    }}
                    alt="logo"
                  />
                </a>
              </ul>
            </div>

            <div className="deleveri d-block d-lg-none">
              <hr style={{ opacity: 1 }} />
            </div>

            <div className="col-lg-3">
              <h5 className="mb-lg-3">
                <b style={{ fontSize: '18px' }}>Địa chỉ trung tâm bảo hành</b>
              </h5>
              <ul className="list-unstyled h-100 p-0">
                {addressStore.map((item, index) => (
                  <li key={item._id}>
                    <div className={index < addressStore.length - 1 ? 'mb-3' : ''} style={{ fontWeight: '300', fontSize: '15px' }}>
                      <Link to={`/tram-bao-hanh/${item.slug}`} className="address-text">
                        <div className="mb-1">
                          <i className="fa fa-map-marker text-primary mx-2" style={{ fontSize: '18px' }}></i>
                          <b>{item.label}</b>
                        </div>
                        {item.store[0].address}
                      </Link>
                    </div>
                  </li>
                ))}
              </ul>
            </div>

            <div className="col-lg-3 d-none d-lg-block">
              <h5 className="mb-lg-3">
                <b style={{ fontSize: '18px' }}>Điều khoản chung</b>
              </h5>
              <ul className="list-unstyled h-100" style={{ paddingLeft: '30px !important' }}>
                <li>
                  <div className="mb-3" style={{ fontWeight: '300', fontSize: '15px' }}>
                    <Link to="/dieu-khoan-chung" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="address-text">
                      Điều khoản chung
                    </Link>
                  </div>
                </li>
                <li>
                  <p className="mb-3" style={{ fontWeight: '300', fontSize: '15px' }}>
                    <Link to="/chinh-sach-van-chuyen" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="address-text">
                      Chính sách vận chuyển
                    </Link>
                  </p>
                </li>
                <li>
                  <p className="mb-3" style={{ fontWeight: '300', fontSize: '15px' }}>
                    <Link to="/chinh-sach-huy-doi-tra" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="address-text">
                      Chính sách đổi trả hàng
                    </Link>
                  </p>
                </li>
                <li>
                  <p className="mb-3" style={{ fontWeight: '300', fontSize: '15px' }}>
                    <Link to="/chinh-sach-thanh-toan" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="address-text">
                      Chính sách thanh toán
                    </Link>
                  </p>
                </li>
                <li>
                  <p className="mb-3" style={{ fontWeight: '300', fontSize: '15px' }}>
                    <Link to="/chinh-sach-bao-mat" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="address-text">
                      Chính sách bảo mật
                    </Link>
                  </p>
                </li>
                <li>
                  <p className="mb-3" style={{ fontWeight: '300', fontSize: '15px' }}>
                    <Link to="/chinh-sach-bao-hanh" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="address-text">
                      Chính sách bảo hành
                    </Link>
                  </p>
                </li>
              </ul>
            </div>

            <div className="deleveri d-block d-lg-none">
              <hr style={{ opacity: 1 }} />
            </div>

            <div className="col-lg-3">
              <h5 className="mb-lg-3">
                <b>Liên hệ với chúng tôi</b>
              </h5>
              <ul className="list-unstyled">
                <li>
                  <p className="mb-2">
                    <i className="fa fa-phone me-2"></i>
                    <span style={{ fontSize: '15px' }}>
                      <b>Hotline: </b>
                      <a href="tel:+1900633870" style={{ fontWeight: '300' }}>
                        1900.633.870
                      </a>
                    </span>
                  </p>
                </li>
                <li>
                  <p className="mb-2">
                    <i className="fa fa-envelope me-2"></i>
                    <span style={{ fontSize: '15px' }}>
                      <b>Email: </b>
                      <span style={{ fontWeight: '300' }}>cs@hoplong.com</span>
                    </span>
                  </p>
                </li>
                <li>
                  <p>
                    <i className="fa fa-envelope me-2"></i>
                    <span style={{ fontSize: '15px' }}>
                      <b>Fanpage: </b>
                      <span style={{ fontWeight: '300' }}>facebook.com/gigacare</span>
                    </span>
                  </p>
                </li>
              </ul>
              <div className="d-flex align-items-center justify-content-evenly justify-content-lg-start">
                <a href="https://www.facebook.com/gigacare" target="_blank" rel="noopener noreferrer">
                  <img
                    src={logoFace}
                    className="position-relative mx-2"
                    style={{
                      width: 40,
                      height: 40,
                      objectFit: 'contain',
                      backgroundColor: 'transparent',
                      mixBlendMode: 'multiply',
                    }}
                    alt="Facebook"
                  />
                </a>
                <a href="https://www.youtube.com/@GIGAvn" target="_blank" rel="noopener noreferrer">
                  <img
                    src={logoYoutube}
                    className="position-relative mx-2"
                    style={{
                      width: 40,
                      height: 40,
                      objectFit: 'contain',
                      backgroundColor: 'transparent',
                      mixBlendMode: 'multiply',
                    }}
                    alt="YouTube"
                  />
                </a>
                <a href="https://zalo.me/2534077125582624767" target="_blank" rel="noopener noreferrer">
                  <img
                    src={logoZalo}
                    className="position-relative mx-2"
                    style={{
                      width: 45,
                      height: 45,
                      objectFit: 'contain',
                      backgroundColor: 'transparent',
                      mixBlendMode: 'multiply',
                      borderRadius: '40px',
                    }}
                    alt="Zalo"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        style={{
          backgroundColor: '#fff',
          borderTop: '1px solid #ddd',
          padding: '20px 0',
          position: 'relative',
        }}
      >
        <div style={{ color: 'rgba(0, 0, 0, .5)', fontSize: '1em' }}>
          <div className="container text-center" style={{ lineHeight: 2 }}>
            Bản quyền thuộc về © CÔNG TY CỔ PHẦN CÔNG NGHỆ HỢP LONG.
            <br />
            Hotline: 1900 6536. Mã số thuế: 0104509916. Đăng ký lần đầu: ngày 05 tháng 03 năm 2010.
            <br />
            Địa chỉ: Tầng 2, tháp A Mandarin Garden 2, số 99 phố Tân Mai, Phường Tương Mai, TP. Hà Nội. <br />
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
